<ideal-image image *renderInCartItemResultLayout="LayoutTargets.Images" [src]="thumbnailUrl()"></ideal-image>
<ideal-product-id-label
  product-id
  line="true"
  [productId]="id()"
  *renderInCartItemResultLayout="LayoutTargets.Title"
></ideal-product-id-label>
<ideal-product-short-description
  description
  line
  [productId]="id()"
  *renderInCartItemResultLayout="LayoutTargets.Description"
></ideal-product-short-description>

<ideal-product-is-canadian
  canadian
  [productId]="id()"
  *renderInCartItemResultLayout="LayoutTargets.Images"
  class="canadian on-image"
></ideal-product-is-canadian>

@if (isCustomCut()) {
  <ideal-product-not-returnable-view
    not-returnable
    line
    [returnable]="false"
    *renderInCartItemResultLayout="LayoutTargets.Notice"
  ></ideal-product-not-returnable-view>
}

<ideal-wire-cut-cart-item-summary [itemId]="id()" *renderInCartItemResultLayout="LayoutTargets.Summary" />

<ideal-cart-item-quantity-selector
  add-to-cart
  cart="main"
  [itemId]="id()"
  *renderInCartItemResultLayout="LayoutTargets.Actions"
></ideal-cart-item-quantity-selector>
